import Icon from '../components/Icon.vue'

Icon.register({
  redo: {
    width: 512,
    height: 512,
    paths: [
      {
        d: 'M500.3 0c6.6 0 12 5.4 12 12v200.3c0 6.6-5.4 12-12 12h-200.3c-6.6 0-12-5.4-12-12v-47.4c0 0 0 0 0 0 0-6.6 5.4-12 12-12 0.2 0 0.4 0 0.6 0l101.5 4.9c-31.6-47-85.1-77.9-146-77.9-97.1 0-176 78.9-176 176s78.9 176 176 176c44.5 0 85.2-16.6 116.2-43.8 2.1-1.8 4.9-3 7.9-3 3.3 0 6.3 1.3 8.5 3.5l34 34c2.2 2.2 3.5 5.2 3.5 8.5 0 3.6-1.5 6.7-4 8.9-43.8 39.7-102.1 63.9-165.8 63.9h-0.4c-136.9 0-247.9-110.9-248-247.8-0.1-136.7 111.3-248.2 248-248.2 0.1 0 0.1-0.1 0.2-0.1 75.6 0 143.3 34 188.7 87.5l-4-82.8c0-0.2 0-0.4 0-0.6 0-6.6 5.4-12 12-12h0 47.4z'
      }
    ]
  }
})
